import { Component, Input } from '@angular/core';
import { TimelineCardComponent } from '../timeline-card/timeline-card.component';
import { TimelineModule } from 'primeng/timeline';
import { AdditionalInformationComponent } from './additional-information/additional-information.component';
import { ProcessStep } from '../../models/process-step.model';

@Component({
  selector: 'hub-timeline',
  standalone: true,
  imports: [TimelineCardComponent, TimelineModule, AdditionalInformationComponent],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
})
export class TimelineComponent {
  @Input() processId: string = '';
  @Input() processName: string = '';
  @Input() processCreatedDate: string = '';
  @Input({ required: true }) steps!: Array<ProcessStep>;

  public processSteps = [
    {
      createdDate: '06-02-2024',
      processStepId: '1',
      status: 'Em processamento',
      step: 'Cadastrar produto',
      stepId: '1',
      username: 'wildson',
      payloadObject: {
        completed: false,
        id: 1,
        title: 'delectus aut autem',
        userId: 1,
      },
    },
    {
      createdDate: '06-02-2024',
      processStepId: '2',
      status: 'Iniciado',
      step: 'Cadastrar produto',
      stepId: '2',
      username: 'pablo',
      payloadObject: {
        completed: false,
        id: 1,
        title: 'delectus aut autem',
        userId: 1,
      },
    },
    {
      createdDate: '06-02-2024',
      processStepId: '3',
      status: 'Em processamento',
      step: 'Cadastrar produto',
      stepId: '3',
      username: 'lucas',
      payloadObject: {
        completed: false,
        id: 1,
        title: 'delectus aut autem',
        userId: 1,
      },
    },
    {
      createdDate: '06-02-2024',
      processStepId: '4',
      status: 'Finalizado',
      step: 'Cadastrar produto',
      stepId: '4',
      username: 'fabiano',
      payloadObject: {
        completed: false,
        id: 1,
        title: 'delectus aut autem',
        userId: 1,
      },
    },
    {
      createdDate: '06-02-2024',
      processStepId: '5',
      status: 'Em processamento',
      step: 'Cadastrar produto',
      stepId: '5',
      username: 'rodrigo',
      payloadObject: {
        completed: false,
        id: 1,
        title: 'delectus aut autem',
        userId: 1,
      },
    },
  ];
}
